import React from 'react';
import AuthPage from './application-center/login-center';

export const LoginCenter = AuthPage;

export const DashboardPage = React.lazy(() => import('./modules/dashboard'));
export const LandingPage = React.lazy(() => import('./modules/login/landing'));
export const UnderConstruction = React.lazy(() =>
  import('./components/UnderConstruction'),
);
export const EspPage = React.lazy(() => import('./modules/esp'));
export const EspDetailPage = React.lazy(() => import('./modules/esp/espDetail'));

export const routes = [
  {
    path: '/view/:service',
    component: React.lazy(() => import('./modules/dashboard/PerformanceNav')),
  },{
    path: '/ppm/epp',
    component: React.lazy(() => import('./modules/dashboard/PerformanceNav')),
  },{
    path: '/subscriptions',
    component: React.lazy(() => import('./modules/dashboard/PerformanceNav')),
  },
  {
    path: '/subscriptions/:aboId/:subscriptionId',
    component: EspDetailPage,
  },
];
